module.exports = __webpack_public_path__ + "img/profesor_1.43e09109.webp";